<template>
    <v-container class="container">
        <v-data-table :headers="headers" :items="action" item-key="ActionId" :search="search" class="elevation-10 ml-2"
            dense loading="dataLoading" loading-text="Loading... Please wait">
            <template v-slot:top>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text">Eleos Actions</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-title>
                    <v-text-field v-model="search" label="Search" append-icon="mdi-magnify" dense>
                    </v-text-field>
                    <v-spacer />
                    <v-spacer />
                    <v-btn class="ml-1" fab large color="secondary" icon to="/catalogs/eleos-actions/form" exact>
                        <v-icon large>mdi-plus-circle</v-icon>
                    </v-btn>
                </v-card-title>
            </template>
            <template v-slot:item.Active="{ item }">
                <v-switch v-model="item.Active" class="mr-3" color="secondary" dense
                    style="margin-top: 0px;padding-top: 0px;" hide-details @change="changeState(item)">
                </v-switch>
            </template>
            <template v-slot:item.EditQB="{ item }">
                <v-combobox placeholder class="mx-3" v-model="item.EditQB" :items="posted" dense hide-details
                    :rules="[v => !!v || 'Required']" :item-text="'name'" :item-value="'id'" auto-select-first @change="changeState(item)">
                </v-combobox>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small class="mx-3" @click="edit(item)">mdi-pencil</v-icon>
                <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    data: function () {
        return {
            dialog: false,
            dataLoading: true,
            edited: {
                ActionId: 0,
                Action: '',
                Active: 1,
            },
            defaultItem: {
                ActionId: 0,
                Action: '',
                Active: 1,
            },
            type: [],
            posted: [
                { id: 1, name: 'Only BOL' },
                { id: 2, name: 'Only Quantitys' },
                { id: 3, name: 'BOL And Quantitys' },
                { id: 4, name: 'Post direct' },
            ],
            headers: [
                { text: 'ID', value: 'ActionId', width: '15%' },
                { text: 'Action', value: 'Action', width: '40%' },
                { text: 'EditQB', value: 'EditQB', width: '30%' },
                { text: 'Active', value: 'Active', width: '10%' },
                {
                    text: 'Options',
                    value: 'action',
                    sortable: false,
                    width: '5%'
                }
            ],
            search: '',
            action: []
        };
    },

    computed: {
        formTitle() {
            return this.edited.id === 0 ? 'New Item' : 'Edit Item';
        }
    },

    watch: {
        dialog(val) {
            val || this.cancel();
        }
    },

    mounted() {
        this.$store.state.editedAction.ActionId = 0;
        this.loadEleosActions();
    },

    methods: {
        loadEleosActions: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('action', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.action = response.data;
                    this.action.forEach(element => {
                        const idx = this.posted.findIndex(x => {
                            return element.EditQB == x.id;
                        });
                        element.EditQB = this.posted[idx];
                    });
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        newEleosAction: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('action', this.edited, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.loadEleosActions();
                    this.cancel();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        deleteEleosAction: function (index) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .delete('action/' + index, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.loadEleosActions();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        changeState: function (item) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            this.edited = Object.assign({}, item);
            var params = {
                Active: this.edited.Active,
                EditQB: this.edited.EditQB.id
            };
            axios
                .put('action/' + this.edited.ActionId, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Actions status changed.'
                    });
                    this.loadEleosActions();
                    this.cancel();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        edit: function (item) {
            this.$store.state.isLoading = true;
            this.edited = Object.assign({}, item);
            this.$store.state.editedAction.ActionId = this.edited.ActionId;
            this.$store.state.isLoading = false;
            this.$router.push('/catalogs/eleos-actions/form');
        },
        deleteItem: function (item) {
            const index = item.id;
            var r = confirm('Are you sure you want to delete?');
            if (r) {
                this.deleteEleosAction(index);
            } else {
                confirm('Canceled');
            }
        },
        save: function () {
            if (this.edited.ActionId > 1) {
                this.editEleosAction();
            } else {
                this.newEleosAction();
            }
            this.cancel();
        },
        cancel: function () {
            this.dialog = false;
            this.edited = Object.assign({}, this.defaultItem);
        }
    }
};
</script>
